const POLL_INTERVAL_MS = 50
const MAX_WAIT_MS = 3000

/**
 * Redirects /inbox to /inbox-v2 before the page renders when the
 * organization's sunset_inbox_v1 permission is on, avoiding the flash of
 * legacy inbox that a mounted()-based redirect would show first.
 *
 * organization/permissions is populated by getOrganizationSettings, which is
 * dispatched from middleware/settings.js (layouts/hub.vue) via a fire-and-
 * forget subscription — that middleware doesn't return/await it, so Nuxt
 * doesn't block navigation on it. On a cold page load this middleware can
 * therefore run before sunset_inbox_v1 has been committed. Poll briefly for
 * it instead of reading the store once — once it's loaded for this session
 * (e.g. any later in-SPA navigation to /inbox) the check resolves instantly.
 *
 * Uses `route.fullPath` (the destination being navigated to), not
 * `window.location`: for an in-SPA `$router.push('/inbox?...')` from another
 * page, the browser's address bar is only updated by Vue Router *after* all
 * middleware resolves, so `window.location` still reflects the previous
 * page while this runs — only a fresh/direct load has it point at /inbox
 * already. Reading `route` avoids that mismatch either way.
 */
export default function ({ store, route }) {
  const getFlag = () => store.state.organization.permissions?.sunset_inbox_v1

  const redirectToInboxV2 = () => {
    window.location.href = route.fullPath.replace(
      /^\/inbox(?=\/|\?|#|$)/,
      '/inbox-v2'
    )
  }

  if (getFlag() === true) {
    redirectToInboxV2()
    return
  }
  if (getFlag() === false) {
    return
  }

  return new Promise((resolve) => {
    let elapsed = 0
    const interval = setInterval(() => {
      elapsed += POLL_INTERVAL_MS
      const flag = getFlag()
      if (flag !== undefined || elapsed >= MAX_WAIT_MS) {
        clearInterval(interval)
        if (flag === true) redirectToInboxV2()
        resolve()
      }
    }, POLL_INTERVAL_MS)
  })
}
